export const admin_routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/admin/pages/Login"),
    meta: { title: "Login" },
  },
  {
    path: "/",
    name: "LandingPage",
    component: () => import("@/views/admin/pages/Landingpage"),
    meta: { title: "Landing Page" },
  },
  {
    path: "/register",
    name: "AdminRegister",
    component: () => import("@/views/admin/pages/Register"),
    meta: { title: "Register" },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("@/views/admin/pages/Login"),
    meta: { title: "Logout" },
  },
  {
    path: "/",
    component: () => import("@/views/admin/Layout"),
    meta: {
      middleware: "advisor-auth",
      title: "Admin Panel",
    },
    children: [
      // Dashboard
      {
        path: "",
        name: "AdminDashboard",
        component: () => import("@/views/admin/pages/Dashboard"),
        meta: { title: "Dashboard" },
      },

      // Profile
      {
        path: "profile",
        name: "MyProfile",
        component: () => import("@/views/admin/pages/Profile/profileindex"),
        meta: { title: "My Profile" },
      },
      {
        path: "profile/signature",
        name: "ProfileSignature",
        component: () => import("@/views/admin/pages/Profile/Signature"),
        meta: { title: "Signature" },
      },

      // Client
      {
        path: "client",
        name: "ClientListing",
        component: () => import("@/views/admin/pages/Partner/Client/Index"),
        meta: { title: "Client Listing" },
      },
      {
        path: "clientmis",
        name: "ClientMISListing",
        component: () => import("@/views/admin/pages/Partner/Client/IndexMis"),
        meta: { title: "Client MIS" },
      },

      // Renewal
      {
        path: "trialrenewal",
        name: "RenewalTrialListing",
        component: () =>
          import("@/views/admin/pages/Partner/Renewal/TrialRenewalIndex"),
        meta: { title: "Trial Renewal" },
      },
      {
        path: "planrenewal",
        name: "RenewalPlanListing",
        component: () =>
          import("@/views/admin/pages/Partner/Renewal/PlanRenewalIndex"),
        meta: { title: "Plan Renewal" },
      },

      // Employee
      {
        path: "employee",
        name: "EmployeeListing",
        component: () => import("@/views/admin/pages/Partner/Employee/Index"),
        meta: { title: "Employee Listing" },
      },
      {
        path: "employee/create",
        name: "EmployeeAdd",
        component: () => import("@/views/admin/pages/Partner/Employee/Create"),
        meta: { title: "Add Employee" },
      },
      {
        path: "employee/edit/:id",
        name: "EmployeeEdit",
        component: () => import("@/views/admin/pages/Partner/Employee/Edit"),
        meta: { title: "Edit Employee" },
      },

      // CRM Setup
      {
        path: "crmSetup",
        name: "CrmSetupList",
        component: () =>
          import("@/views/admin/pages/CRM/CrmSetup/CrmSetupList"),
        meta: { title: "CRM Setup" },
      },

      // CRM Details
      {
        path: "crmcontact",
        name: "CRMContact",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/CRMContact"),
        meta: { title: "CRM Contact" },
      },
      {
        path: "contactcreate",
        name: "ContactCreate",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/CRMContactCreate"),
        meta: { title: "Create Contact" },
      },
      {
        path: "crmcontactedit/:id",
        name: "CRMContactEdit",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/CRMContactEdit"),
        meta: { title: "Edit Contact" },
      },
      {
        path: "crmcontactview/:id",
        name: "CRMContactView",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/CRMContactView"),
        meta: { title: "View Contact" },
      },
      {
        path: "crmfollowupadd/:id",
        name: "CRMFollowupAdd",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/Followup/CRMFollowupAdd"),
        meta: { title: "Add Followup" },
      },
      {
        path: "crmfollowcontactedit/:id",
        name: "CRMFollowContactEdit",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/Followup/CRMFollowupEdit"),
        meta: { title: "Edit Followup" },
      },
      {
        path: "crmfollowcontactview/:id",
        name: "CRMFollowContactView",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/Followup/CRMFollowupView"),
        meta: { title: "View Followup" },
      },
      {
        path: "crmfollowupdetails",
        name: "CRMFollowUPDetails",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/Followup/FollowUPDetails"),
        meta: { title: "Followup Details" },
      },
      {
        path: "crmhistoryfollowupadd/:id",
        name: "CRMHistoryFollowupAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRM/CrmDetails/Followup/CRMHistoryFollowupAdd"
          ),
        meta: { title: "History Followup" },
      },
      {
        path: "crmopentask",
        name: "CRMOpenTask",
        component: () =>
          import("@/views/admin/pages/CRM/CrmDetails/Followup/CRMOpenTask"),
        meta: { title: "Open Tasks" },
      },

      // Template
      {
        path: "template",
        name: "TemplateListing",
        component: () => import("@/views/admin/pages/Template/Index"),
        meta: { title: "Template Listing" },
      },
      {
        path: "template/create",
        name: "TemplateAdd",
        component: () => import("@/views/admin/pages/Template/Create"),
        meta: { title: "Create Template" },
      },
      {
        path: "template/edit/:id",
        name: "TemplateEdit",
        component: () => import("@/views/admin/pages/Template/Edit"),
        meta: { title: "Edit Template" },
      },
      {
        path: "template/view/:id",
        name: "TemplateView",
        component: () => import("@/views/admin/pages/Template/Views"),
        meta: { title: "View Template" },
      },

      // Ledger
      {
        path: "ledger",
        name: "LedgerListing",
        component: () => import("@/views/admin/pages/Ledger/Index"),
        meta: { title: "Ledger Listing" },
      },
    ],
  },
];
